import { DisabledTimes } from './TimePicker';
import { TimeOption } from './TimePickerOptions';

export const getTimePickerOptions = (
  length: number,
  increment = 1,
  disabledValues: number[] = [],
  hideDisabled?: boolean,
): TimeOption[] => {
  const output: TimeOption[] = [];
  let index = 0;
  for (let item = 0; item < length; item += increment) {
    const disabled = disabledValues.includes(item);
    if (hideDisabled && disabled) {
      continue;
    }
    output.push({
      label: `${String(item).padStart(2, '0')}`,
      value: item,
      index,
      disabled,
    });
    index += 1;
  }
  return output;
};

export const getTimePickerOption = (options: TimeOption[], value: TimeOption['value']) => {
  return options.find((option) => option.value === value);
};

export const getDisabledTimes = (
  disabledTimeFn?: (date: Date, range?: 'from' | 'to') => DisabledTimes,
  date?: Date,
  range?: 'from' | 'to',
) => {
  // @ts-expect-error: TS2345
  const times = disabledTimeFn ? disabledTimeFn(date, range) : null;
  return {
    disabledHours: times?.disabledHours ? times.disabledHours() : [],
    disabledMinutes: times?.disabledMinutes ? times.disabledMinutes(date?.getHours() ?? 0) : [],
  };
};

export const getDisabledTime = (timePickerOptions: TimeOption[], time?: number) => {
  return timePickerOptions.find((option) => option.value === Number(time))?.disabled;
};

export const getAvailableSelectedTime = (timePickerOptions: TimeOption[]) => {
  return timePickerOptions.find(({ disabled }) => !disabled)?.value;
};
